import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "edit-product-container max-w-4xl mx-auto py-6 px-4 sm:px-6 lg:px-8" }
const _hoisted_2 = { class: "mb-6 flex justify-between items-center" }
const _hoisted_3 = {
  key: 0,
  class: "bg-gray-800 shadow rounded-lg p-6 text-center"
}
const _hoisted_4 = {
  key: 1,
  class: "bg-gray-800 shadow rounded-lg p-6 text-center"
}
const _hoisted_5 = { class: "text-red-500 text-lg" }
const _hoisted_6 = {
  key: 2,
  class: "bg-gray-800 shadow rounded-lg px-4 py-5 sm:p-6 overflow-hidden"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ProductEditForm = _resolveComponent("ProductEditForm")!
  const _component_ToastNotification = _resolveComponent("ToastNotification")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", null, [
        _createElementVNode("h1", { class: "text-2xl font-bold text-white mb-2" }, "Izmeni oglas"),
        _createElementVNode("p", { class: "text-gray-400" }, "Ažurirajte podatke o proizvodu")
      ], -1)),
      _createElementVNode("div", null, [
        _createVNode(_component_router_link, {
          to: "/my-listings",
          class: "px-4 py-2 text-sm rounded-md bg-gray-700 text-white hover:bg-gray-600 transition-colors"
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode(" Nazad na moje oglase ")
          ])),
          _: 1
        })
      ])
    ]),
    (_ctx.isLoading && !_ctx.isDataLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[4] || (_cache[4] = [
          _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500 mx-auto" }, null, -1),
          _createElementVNode("p", { class: "mt-4 text-gray-300" }, "Učitavanje podataka...", -1)
        ])))
      : (_ctx.error && !_ctx.isDataLoaded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[5] || (_cache[5] = _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "h-10 w-10 mx-auto mb-2",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                })
              ], -1)),
              _createElementVNode("p", null, _toDisplayString(_ctx.error), 1)
            ]),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadProduct(_ctx.$route.params.id as string))),
              class: "mt-4 px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700 transition-colors"
            }, " Pokušaj ponovo ")
          ]))
        : (_ctx.isDataLoaded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_ProductEditForm, {
                "form-data": _ctx.formData,
                "is-loading": _ctx.isLoading,
                categories: _ctx.categories,
                onAddImage: _ctx.addImage,
                onRemoveImage: _ctx.removeImage,
                onSetMainImage: _ctx.setMainImage,
                onRotateImage: _ctx.rotateImage,
                onUpdateProduct: _ctx.updateProduct,
                onCancelChanges: _ctx.cancelChanges
              }, null, 8, ["form-data", "is-loading", "categories", "onAddImage", "onRemoveImage", "onSetMainImage", "onRotateImage", "onUpdateProduct", "onCancelChanges"])
            ]))
          : _createCommentVNode("", true),
    _createVNode(_component_ToastNotification, {
      show: _ctx.toast.show,
      message: _ctx.toast.message,
      type: _ctx.toast.type,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toast.show = false))
    }, null, 8, ["show", "message", "type"])
  ]))
}